import { DataTableExRef, TablePageLayout } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React, { useRef } from 'react';

import { FeaturedTemplatesTable } from 'components/FeaturedTemplatesTable';

export function FeaturedTemplates() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <TablePageLayout
      title="Слайдер"
      actionContent={
        <Button
          sx={{ ml: 5 }}
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            tableRef.current?.openFormDialog();
          }}
        >
          Добавить слайд
        </Button>
      }
    >
      <FeaturedTemplatesTable
        id="featured-templates-table"
        ref={tableRef}
        searchFilter={{
          inputProps: {
            placeholder: 'Поиск по тексту',
          },
          filter: (search) => ({
            text: { _ilike: `%${search}%` },
          }),
        }}
      />
    </TablePageLayout>
  );
}
